import React, { SVGProps } from 'react';

const FailedIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.2137 2.16714C13.5954 1.78538 13.5954 1.16807 13.2137 0.790378C12.8319 0.412683 12.2146 0.408622 11.8369 0.790378L7.00406 5.62324L2.16714 0.786317C1.78538 0.404561 1.16807 0.404561 0.790378 0.786317C0.412683 1.16807 0.408622 1.78538 0.790378 2.16307L5.62324 6.99594L0.786317 11.8329C0.404561 12.2146 0.404561 12.8319 0.786317 13.2096C1.16807 13.5873 1.78538 13.5914 2.16307 13.2096L6.99594 8.37676L11.8329 13.2137C12.2146 13.5954 12.8319 13.5954 13.2096 13.2137C13.5873 12.8319 13.5914 12.2146 13.2096 11.8369L8.37676 7.00406L13.2137 2.16714Z"
				fill="#FA924F"
			/>
		</svg>
	);
};

export default FailedIcon;
